import { storyblokInit as s } from "./storyblok-js.mjs";
import { RichTextResolver as g, RichTextSchema as C, apiPlugin as d, loadStoryblokBridge as f, registerStoryblokBridge as S, renderRichText as x, storyblokEditable as F, registerStoryblokBridge as A } from "./storyblok-js.mjs";
import { default as B } from "./storyblok-component.mjs";
let t = null, e = {}, r = !1, l = null;
const b = () => (t || console.error(
  "You can't use getStoryblokApi if you're not loading apiPlugin."
), t), c = (o) => (e = o, e), i = (o) => e[o] ? e[o] : (console.error(`Component ${o} doesn't exist.`), !1), k = () => r, m = () => l, p = (o = {}) => {
  const { storyblokApi: n } = s(o);
  t = n, e = o.components, r = o.enableFallbackComponent, l = o.customFallbackComponent;
};
export {
  g as RichTextResolver,
  C as RichTextSchema,
  B as StoryblokComponent,
  d as apiPlugin,
  i as getComponent,
  m as getCustomFallbackComponent,
  k as getEnableFallbackComponent,
  b as getStoryblokApi,
  f as loadStoryblokBridge,
  S as registerStoryblokBridge,
  x as renderRichText,
  c as setComponents,
  F as storyblokEditable,
  p as storyblokInit,
  b as useStoryblokApi,
  A as useStoryblokBridge
};
